import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiSelectModule } from '@taiga-ui/legacy';
import { TuiDataListWrapper } from '@taiga-ui/kit';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '@src/app/modules/icon';

import { LanguageSwitcherComponent, LanguageSwitcherMiniComponent } from './components';

@NgModule({
  declarations: [LanguageSwitcherComponent, LanguageSwitcherMiniComponent],
  imports: [
    CommonModule,
    IconModule,
    TranslateModule,
    TuiSelectModule,
    ...TuiDataListWrapper,
    TuiTextfieldControllerModule,
    FormsModule,
  ],
  exports: [LanguageSwitcherComponent, LanguageSwitcherMiniComponent],
})
export class LanguageSwitcherModule {}
